<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
      <form class="form" autocomplete="off">
        <div class=" px-5 box" @click="isVisibleEnterResult = true"
             :class="isVisibleEnterResult ? 'box-expanded' : 'button-enter'">
          <p class="mb-0" v-if="!isVisibleEnterResult">Bấm vào để Nhập kết quả xử lý</p>
          <div v-if="isVisibleEnterResult" class="py-5">
            <div>
              <p>Phương án xử lý <span style="color:red;">*</span></p>
              <ValidationProvider name="Chọn phương án xử lý" rules="required" v-slot="{ errors,classes }"
                                  vid="choose_handel">
                <el-select v-model="result.solution" placeholder="Chọn phương án xử lý" style="width: 50%" size="small">
                  <el-option
                      v-for="item in solutionOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
                <div class="fv-plugins-message-container">
                  <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </div>
            <div class="mt-3">
              <p>Ghi chú xử lý</p>
              <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="Nhập Ghi chú xử lý"
                  v-model="result.note">
              </el-input>
            </div>
            <div class="mt-3">
              <p>Đo lường sau xử lý</p>
              <el-switch v-model="result.isAfterProcessing">
              </el-switch>
            </div>
            <div v-if="result.isAfterProcessing" class="mt-3 row">
              <div class="col-lg-6" v-if="isTeachingOrCompetencyError">
                <p>Thời gian đo lường<span style="color:red;">*</span></p>
                <ValidationProvider name="Thời gian đo lường" rules="required" v-slot="{ errors,classes }"
                                    vid="measurement_time">
                  <el-date-picker
                      v-model="result.measurementTime"
                      @change="result.resultTime = null"
                      type="daterange"
                      range-separator="đến"
                      start-placeholder="Từ ngày"
                      end-placeholder="Đến ngày"
                      align="right"
                      unlink-panels
                      clearable
                      size="medium"
                      format="dd/MM/yyyy"
                      value-format="yyyy-MM-dd"
                      class="w-100"
                  />
                  <div class="fv-plugins-message-container">
                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
              <div class="col-lg-6" v-if="isTeachingOrCompetencyError">
                <p>Thời gian nhận kết quả<span style="color:red;">*</span></p>
                <ValidationProvider name="Thời gian nhận kết quả" rules="required" v-slot="{ errors,classes }"
                                    vid="result_time">
                  <el-date-picker
                      v-model="result.resultTime"
                      :disabled="!result.measurementTime.length"
                      format="dd/MM/yyyy HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      placeholder="Chọn thời gian nhận kết quả" size="medium" class="w-100"
                      :picker-options="resultTimeOptions"
                  >
                  </el-date-picker>
                  <div class="fv-plugins-message-container">
                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
              <div class="col-lg-6 mt-3">
                <p>Mục tiêu </p>
                <div>
                    <div style="position: relative">
                      <el-input
                          v-model="result.target"
                          placeholder="Điền mục tiêu"
                      >
                        <span slot="suffix" ></span>
                      </el-input>
                      <span style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%)">%</span>
                    </div>
                </div>

              </div>
              <div class="col-lg-12 mt-5" v-if="isFinalOrMidterm">
                <i v-if="isFinal" style="color: #5E00B6; font-weight: 400 ; font-size: 13px">Hệ thống tự động trả kết quả Tỉ lệ pass final sau 25 ngày kể từ thời điểm báo lỗi.</i>
                <i  v-else style="color: #5E00B6; font-weight: 400; font-size: 13px"  >Hệ thống tự động trả kết quả Tỉ lệ pass
                  final lần 1 khi cả lớp kiểm tra cuối khóa.</i>

              </div>

            </div>
            <div class="mt-3 d-flex justify-content-end">
              <button type="button" class="btn btn-secondary mr-4" @click.stop="cancelEnterResult()" :disabled="loading">Hủy</button>
              <button type="button" class="btn btn-info" @click="handleSubmit(saveResult)" :disabled="loading"><i v-if="loading" class="el-icon-loading"></i> Lưu kết quả</button>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import {
  RATE_COMPETENCY,
  RATE_PASS_FINAL_1, RATE_PASS_MIDTERM,
  RATE_TEACHING_ERROR,
  SOLUTION_LIST
} from "../../../../../core/option/leaderRadarOption";
import {
  GET_ISSUES_OF_QUALITY,
  POST_HANDLE_RESULT
} from "../../../../../core/services/store/report-error/reportError.module";

export default {
  name: "HandlingResultSelect",
  props: {
    errorType: {
      type: Number || null
    },
    solutionOption:{
      type: Array || null
    }
  },
  data() {
    return {
      isVisibleEnterResult: false,
      result: {
        solution: null,
        note: '',
        isAfterProcessing: false,
        measurementTime: [],
        resultTime: null,
        target: null
      },
      loading: false
    }
  },
  mounted() {

  },
  computed: {
    // solutionOption() {
    //   return SOLUTION_LIST[this.errorType]
    // },
    isTeachingOrCompetencyError() {
      return [RATE_TEACHING_ERROR, RATE_COMPETENCY].includes(this.errorType)
    },
    isFinalOrMidterm() {
      return [RATE_PASS_FINAL_1, RATE_PASS_MIDTERM].includes(this.errorType)
    },
    isFinal(){
      return RATE_PASS_FINAL_1 === this.errorType
    },
    resultTimeOptions() {
      const measurementRange = this.result.measurementTime
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      let minDate = today
      if (Array.isArray(measurementRange) && measurementRange[1]) {
        const endDate = new Date(measurementRange[1])
        endDate.setHours(0, 0, 0, 0)
        minDate = endDate > today ? endDate : today
      }
      return {
        disabledDate(time) {
          // Không cho chọn ngày <= minDate
          return time.getTime() <= minDate.getTime()
        }
      }
    }
  },
  methods: {
    cancelEnterResult() {
      this.isVisibleEnterResult = false;
      this.result = {
        solution: null,
        note: '',
        isAfterProcessing: false,
        measurementTime: [],
        resultTime: null,
        target: null
      }
    },
    async saveResult() {
      this.loading = true
      try {
        const data = {
          id: this.$route.params?.id,
          payload: {
            "handling_option_id": this.result.solution,
            "handling_note": this.result.note,
            "measure_after":this.result.isAfterProcessing,
            "measurement_from": this.result.measurementTime[0],
            "measurement_to": this.result.measurementTime[1],
            "measurement_target_percent": this.result.target,
            "measurement_result_at": this.result.resultTime
          }
        }
        await this.$store.dispatch(POST_HANDLE_RESULT,data)
        this.result = {
          solution: null,
          note: '',
          isAfterProcessing: false,
          measurementTime: [],
          resultTime: null,
          target: null
        }
        this.isVisibleEnterResult = false;
        this.$notify({
          title: 'Nhập kết quả xử lý',
          message: 'Thành công',
          type: 'success'
        });
        this.$emit('getApiReload')
      }catch (e) {
        this.$notify.error({
          title: 'Lỗi',
          message: `${e?.data?.message??'Nhập kết quả thất bại'}`
        });
      }finally {
        this.loading = false
      }



    }
  }
}
</script>

<style scoped>
.box {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  overflow: hidden;
  transition: max-height 1s ease; /* hiệu ứng mở rộng */
}

/* Trạng thái thu gọn */
.button-enter {
  height: 50px;
  max-height: 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 1px solid #5E00B6;
}

.button-enter:hover {
  border: 1px solid #5E00B6;
}

/* Trạng thái mở ra */
.box-expanded {
  background-color: #FAFAFA;
  border: 1px solid #5E00B6;
  max-height: 700px; /* đủ lớn để chứa input */
}

</style>